function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n    .st0{opacity:0.15;fill:#1EA3CE;}\n    .st1{fill:#7D5544;}\n    .st2{fill:#F1C29A;}\n    .st3{fill:#663521;}\n    .st4{fill:#FFFFFF;}\n    .st5{opacity:0.1;fill:#1B1D21;}\n    .st6{fill:#1BA3CE;}\n    .st7{fill:#F8BBBC;}\n    .st8{fill:#ECA3AD;}\n    .st9{fill:#231F20;}\n    .st10{fill:#5C6169;}\n    .st11{fill:#D4D2CF;}\n    .st12{fill:#F7C8BF;}\n    .st13{fill:#414042;}\n    .st14{fill:#1C4270;}\n    .st15{opacity:5.000000e-02;fill:#1B1D21;}\n    .st16{fill:#1EA3CE;}\n    .st17{fill:#FF9E00;}\n    .st18{fill:none;}\n    .st19{fill:#ECAE8D;}\n    .st20{fill:#7F572A;}\n    .st21{fill:#A17940;}\n    .st22{opacity:0.15;fill:#1BA3CE;}\n    .st23{fill:#D5D2D0;}\n    .st24{fill:#F9BCBD;}\n    .st25{fill:#EDA4AE;}\n    .st26{fill:#675B5B;}\n    .st27{fill:#E6E6E6;}\n    .st28{fill:#501616;}\n    .st29{fill:#333B44;}\n    .st30{opacity:0.99;fill:#E6E6E6;enable-background:new    ;}\n    .st31{fill:#A02C2C;}\n    .st32{fill:#784421;}\n    .st33{fill:#A05A2C;}\n    .st34{fill:#00BA6B;}\n    .st35{fill:#E6A800;}\n    .st36{fill:#88949F;}\n    .st37{opacity:0.45;fill:#00BA6B;}\n    .st38{fill:#7F3DB3;}\n    .st39{fill:#5B3A2F;}\n    .st40{fill:#B58361;}\n    .st41{fill:#FF9F00;}\n    .st42{fill:#1DA3CE;}\n    .st43{fill:#1AA3CE;}\n    .st44{opacity:0.3;fill:#1AA3CE;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_12"
}, React.createElement("path", {
  className: "st0",
  d: "M-134.7,182.6c64.5,0,102.9-7.5,134.8-15.3V52.1c-4.2,1-8.3,2.1-12.3,3.1C-45.2,63.7-73.6,71-134.7,71         c-61.1,0-89.5-7.3-122.5-15.7c-34-8.7-72.3-18.6-142.8-19.2v111.7c56,0.6,83.5,7.6,115,15.7C-249.8,172.4-210,182.6-134.7,182.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M137.9,147.6c61.1,0,89.5,7.3,122.5,15.7c33.5,8.6,71.2,18.3,139.6,19.2V70.9c-53.9-0.8-80.9-7.7-111.9-15.7         c-35.2-9-75-19.3-150.2-19.3C71.3,36,32.4,44,0,52.1v115.2c5.3-1.3,10.4-2.6,15.5-3.9C48.4,154.9,76.8,147.6,137.9,147.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M697.1,145.9c29.9-7.7,47.8-38.1,40.2-67.9c-7.6-29.9-38.1-47.9-67.9-40.2C668.1,38.1,537.9,71,410.6,71         c-3.6,0-7.2,0-10.6-0.1v111.6c3.5,0,7,0.1,10.6,0.1C552.3,182.6,691.3,147.4,697.1,145.9z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_6"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_8"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_7"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st12",
  d: "M128.6,123.5c0.4-0.7,0.8-1.3,1.3-1.9l-6.3-2.6l-3.3-3.6l-4.7,3.9l0.1,1.7l3,3.2l9.6,4                 C127.7,127.2,127.5,125.7,128.6,123.5z"
}), React.createElement("polygon", {
  className: "st6",
  points: "116.7,133.8 116.7,133.8 116.7,133.8            "
}), React.createElement("path", {
  className: "st6",
  d: "M108.3,136.5c-6.1,3.3-10.6,1.7-12.5,0.6l0.6,5.8c0.4,0,0.8,0,1.1,0.2c1.9,0.7,2.6,3.2,1.7,5.7                 c5.7-0.4,11.8-0.7,18.2-0.9l-0.6-11.5C116.3,136.3,111.1,135,108.3,136.5z"
}), React.createElement("path", {
  className: "st34",
  d: "M120.9,115l-5.6-7.1c-1.3-1.6-4-2.7-6.5-2.8c-0.9-0.3-1.9-0.4-3-0.4c-2.2,0-4.4,0.5-6.3,1.8                 c-1.8,0.7-3.6,2.6-4.6,5.2l-3.1,8l0.9,0.3l5.5,2.1l-2.9,12l0.3,3.1c1.9,1,6.4,2.6,12.5-0.6c2.8-1.5,8-0.1,8.5,0c0,0,0.1,0,0.1,0                 l-0.2-2.7l0,0l-0.9-12.8l-0.1-1.7l4.7-3.9L120.9,115z"
}), React.createElement("path", {
  className: "st12",
  d: "M134.5,120.1c-1.6-0.6-3.3,0.1-4.6,1.5c-0.5,0.5-0.9,1.2-1.3,1.9c-1.1,2.2-1,3.7-0.3,4.7                 c0.6,0.8,1.5,1.4,2.5,1.7c2.2,0.8,4.9-0.7,5.9-3.4C137.7,123.8,136.7,120.9,134.5,120.1z"
}), React.createElement("path", {
  className: "st12",
  d: "M97.5,143.1c-0.4-0.1-0.7-0.2-1.1-0.2l-0.6-5.8l-0.3-3.1l2.9-12l-5.5-2.1l-1.9,12c-0.2,1.4-0.3,2.8-0.3,4.2                 l1.4,12.5c0,0.2,0,0.4,0.1,0.6c2.3-0.2,4.7-0.4,7.2-0.5C100.1,146.4,99.3,143.8,97.5,143.1z"
}))), React.createElement("g", null, React.createElement("path", {
  className: "st35",
  d: "M122.5,68.2c5.8,5.9,10.4,25.2-2.3,29.9c-10.7,3.9-34.7,2.1-35.5-7.1c-1.3-14.6,5.5-31.6,22.3-30             C112.3,61.4,116.6,62.3,122.5,68.2z"
}), React.createElement("path", {
  className: "st12",
  d: "M124.9,85.4c-0.5-0.2-0.9-0.1-1.3,0.2c-0.2-10.2-7.3-18.4-16.8-18.4c-9.5,0-16,8.1-16.3,18.3             c-0.6-0.2-1.2-0.2-1.8,0c-1.9,0.8-3,3.1-1.8,6.1c0.8,2,3.3,3.5,5.3,3.2c2.1,4.8,5.9,8.4,10.9,9.6c0,0.2,0,0.3,0,0.6             c0,1.2,1.3,2.3,2.9,2.3c1.6,0,2.9-1,2.9-2.3c0-0.1,0-0.2,0-0.3c6.1-0.8,10.9-4.9,13.2-10.6c1.6-0.2,3.9-1.9,4.5-3.7             C127.4,87.6,126.2,85.9,124.9,85.4z"
}), React.createElement("ellipse", {
  className: "st3",
  cx: 101.3,
  cy: 88.9,
  rx: 1.8,
  ry: 2.6
}), React.createElement("ellipse", {
  className: "st3",
  cx: 115.2,
  cy: 88.9,
  rx: 1.8,
  ry: 2.6
}), React.createElement("path", {
  className: "st4",
  d: "M108.3,100.6c-3,0-5.4-2.2-5.8-5.1c0-0.4,0.3-0.7,0.6-0.7h10.3c0.4,0,0.7,0.3,0.6,0.7             C113.7,98.4,111.3,100.6,108.3,100.6z"
}), React.createElement("path", {
  className: "st35",
  d: "M116.9,67.2c-1.8-1.5-4.9-2.7-10.5-2.8c-16.7-0.1-25.6,14.4-13.8,16.9c7.7,1.6,16.2-1.6,21.3-4.1             c2.2,2.2,5.1,4.5,7.9,4.5C127.3,81.7,124.4,70.1,116.9,67.2z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st5",
  d: "M134.5,120.1c-1.6-0.6-3.3,0.1-4.6,1.5l-6.3-2.6l-3.3-3.6l0.5-0.4l-5.6-7.1c-1.3-1.6-4-2.7-6.5-2.8             c5.3,17.6,3.2,31.8,1.2,43.3l7.4-0.3l-0.6-11.4c0,0,0,0,0,0l-0.1-1.5v0l-0.1-1.2l0,0h0l-0.9-12.8l3,3.2l9.6,4             c0.6,0.8,1.5,1.4,2.5,1.7c2.2,0.8,4.9-0.7,5.9-3.4C137.7,123.8,136.7,120.9,134.5,120.1z"
}), React.createElement("path", {
  className: "st5",
  d: "M109.2,104.7c4.4-0.7,8-3,10.6-6.5c0.1,0,0.3-0.1,0.4-0.1c12.7-4.7,8.2-24,2.3-29.9c0,0-0.1-0.1-0.1-0.1             C127.2,77.3,126.7,92,109.2,104.7z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st6",
  d: "M142.9,123.9c4.6,1.7,6.9,6.7,5.2,11.3c-1.7,4.6-6.7,6.9-11.3,5.2c-4.6-1.7-6.9-6.7-5.2-11.3             C133.2,124.6,138.3,122.3,142.9,123.9 M143.5,122.2c-5.5-2-11.7,0.8-13.7,6.4c-2,5.5,0.8,11.7,6.4,13.7c5.5,2,11.7-0.8,13.7-6.4             C151.9,130.3,149,124.2,143.5,122.2L143.5,122.2z"
}), React.createElement("path", {
  className: "st6",
  d: "M140.8,150.8l4.3-9.2c0.1-0.3,0.4-0.4,0.7-0.5l10.4-0.6c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.2,0.5,0.1,0.7             l-0.4,1.2c-0.1,0.2-0.2,0.3-0.3,0.4l-14.3,8.6c0,0-0.1,0-0.1,0c-0.3,0.1-0.6,0.1-0.9-0.1C140.7,151.5,140.6,151.1,140.8,150.8z"
}), React.createElement("path", {
  className: "st5",
  d: "M145.7,141.1l10.4-0.6c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.2,0.5,0.1,0.7l-0.4,1.2c-0.1,0.2-0.2,0.3-0.3,0.4             l-14.3,8.6c0,0-0.1,0-0.1,0c-0.3,0.1-0.6,0.1-0.9-0.1c-0.3-0.2-0.3-0.6-0.2-0.9l4.3-9.2C145.2,141.3,145.5,141.2,145.7,141.1z"
}), React.createElement("path", {
  className: "st6",
  d: "M134.7,152.4L134.7,152.4c4.4,1.6,9.3-0.7,11-5.1l4.2-11.5l-16-5.9l-4.2,11.5             C128,145.9,130.3,150.8,134.7,152.4z"
}), React.createElement("path", {
  className: "st5",
  d: "M148.1,135.2c1.4-3.9-0.1-8.1-3.3-10.3l0.7-1.8c4.2,2.6,6.2,7.9,4.4,12.8L148,141l8.2-0.5             c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.2,0.5,0.1,0.7l-0.4,1.2c-0.1,0.2-0.2,0.3-0.3,0.4l-14.3,8.6c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0             c-2.1,1.2-4.6,1.4-7.1,0.6l7.1-19.5L148.1,135.2z"
})), React.createElement("path", {
  className: "st6",
  d: "M167.8,150.1c-0.5,0-0.9-0.4-0.9-0.9c0-3.7-3-6.6-6.6-6.6c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9         c4.6,0,8.4,3.8,8.4,8.4C168.7,149.7,168.3,150.1,167.8,150.1z"
}), React.createElement("path", {
  className: "st6",
  d: "M165.6,150.1c-0.5,0-0.9-0.4-0.9-0.9c0-2.4-2-4.4-4.4-4.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9         c3.4,0,6.2,2.8,6.2,6.2C166.5,149.7,166.1,150.1,165.6,150.1z"
}), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M167.6,153.3c-2.4,2.4-1.7,6.9-1.7,6.9s4.5,0.7,6.9-1.7c2.4-2.4,1.7-6.9,1.7-6.9S170,151,167.6,153.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M167.6,153.3c-2.4,2.4-1.7,6.9-1.7,6.9s4.5,0.7,6.9-1.7c2.4-2.4,1.7-6.9,1.7-6.9S170,151,167.6,153.3z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M174.6,162.9c-1.6,1.6-1.2,4.7-1.2,4.7s3.1,0.4,4.7-1.2s1.2-4.7,1.2-4.7S176.2,161.3,174.6,162.9z"
}), React.createElement("path", {
  className: "st5",
  d: "M174.6,162.9c-1.6,1.6-1.2,4.7-1.2,4.7s3.1,0.4,4.7-1.2s1.2-4.7,1.2-4.7S176.2,161.3,174.6,162.9z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M193.4,172.4h-1.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.3c0.6,0,1-0.4,1-1S194,172.4,193.4,172.4z"
}), React.createElement("path", {
  className: "st34",
  d: "M187.4,172.4h-2.2c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.2c0.6,0,1-0.4,1-1S187.9,172.4,187.4,172.4z"
}), React.createElement("path", {
  className: "st34",
  d: "M179.7,172.4h-4.9v-4.9c0,0,0,0,0,0s0.4-3.1-1.2-4.7s-4.7-1.2-4.7-1.2s-0.4,3.1,1.2,4.7                 c0.9,0.9,2.2,1.1,3.2,1.2v4.8h-5.6v-12.2c0.2,0,0.2,0,0.2,0s0.7-4.5-1.7-6.9c-2.4-2.4-6.9-1.7-6.9-1.7s-0.7,4.5,1.7,6.9                 c1.3,1.3,3.3,1.7,4.8,1.8v12.2h-12.6c-0.6,0-1,0.4-1,1s0.4,1,1,1h26.4c0.6,0,1-0.4,1-1S180.3,172.4,179.7,172.4z"
}))), React.createElement("g", null, React.createElement("path", {
  className: "st4",
  d: "M223.7,124h-44.7c-3.2,0-5.2-3.4-3.8-6.2c8.3-16.8,9-45.8,8.9-56.7c0-2.4,1.9-4.3,4.3-4.3h45.5             c2.4,0,4.3,2,4.3,4.4c-0.2,12.8-1.7,50.2-11.3,61.4C226.1,123.5,224.9,124,223.7,124z"
}), React.createElement("path", {
  className: "st36",
  d: "M227.8,78.7H207c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h20.8c0.8,0,1.5,0.7,1.5,1.5S228.6,78.7,227.8,78.7z             "
}), React.createElement("path", {
  className: "st36",
  d: "M226.1,92.6h-20.8c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h20.8c0.8,0,1.5,0.7,1.5,1.5             S226.9,92.6,226.1,92.6z"
}), React.createElement("path", {
  className: "st36",
  d: "M222.8,106.5H202c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h20.8c0.8,0,1.5,0.7,1.5,1.5             S223.6,106.5,222.8,106.5z"
}), React.createElement("path", {
  className: "st34",
  d: "M193.2,81.5c-0.4,0-0.8-0.1-1.1-0.4l-2.8-2.8c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l1.8,1.8l4.6-4.6             c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-5.7,5.7C194,81.4,193.6,81.5,193.2,81.5z"
}), React.createElement("path", {
  className: "st34",
  d: "M191.6,95.4c-0.4,0-0.8-0.1-1.1-0.4l-2.8-2.8c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l1.8,1.8l4.6-4.6             c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-5.7,5.7C192.3,95.3,192,95.4,191.6,95.4z"
}), React.createElement("path", {
  className: "st34",
  d: "M188.2,109.4c-0.4,0-0.8-0.1-1.1-0.4l-2.8-2.8c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l1.8,1.8             l4.6-4.6c0.6-0.6,1.5-0.6,2.1,0c0.6,0.6,0.6,1.5,0,2.1l-5.7,5.7C189,109.2,188.6,109.4,188.2,109.4z"
}), React.createElement("rect", {
  x: 201.1,
  y: 54.3,
  className: "st36",
  width: 20.8,
  height: 7.4
}), React.createElement("circle", {
  className: "st36",
  cx: 211.4,
  cy: 54.3,
  r: 4.9
}), React.createElement("path", {
  className: "st5",
  d: "M233.9,56.8h-12v-2.5h-5.6c0-2.7-2.2-4.8-4.8-4.9c5.9,24.9-0.1,55.6-10.6,74.5h22.8c1.2,0,2.4-0.5,3.2-1.4             c9.7-11.2,11.1-48.6,11.3-61.4C238.3,58.8,236.3,56.8,233.9,56.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M309.1,132.1c-1.5,0-2.8-1.1-3-2.6c-0.2-1.3-4.2-31.1,13.4-44.1c1.3-1,3.2-0.7,4.2,0.6             c1,1.3,0.7,3.2-0.6,4.2c-14.7,10.9-11,38.2-11,38.5c0.2,1.6-0.9,3.2-2.5,3.4C309.4,132.1,309.2,132.1,309.1,132.1z"
}), React.createElement("path", {
  className: "st34",
  d: "M294.2,133.4c0,0-0.1,0-0.1,0c-1.7-0.1-2.9-1.5-2.9-3.1c1.1-28.4-7.6-36.2-7.7-36.2c-1.3-1-1.5-2.9-0.5-4.2             c1-1.3,2.9-1.5,4.2-0.5c1.1,0.9,11.2,9.7,9.9,41.1C297.1,132.1,295.8,133.4,294.2,133.4z"
}), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M277.3,78.1c5.4,2.5,8.4,13,8.4,13s-3.7-2.7-9.2-5.2c-5.4-2.5-10.4-3.8-10.4-3.8S271.9,75.6,277.3,78.1z"
}), React.createElement("path", {
  className: "st34",
  d: "M273.4,87.6c5.5-2.3,12.2,3.3,12.2,3.3s-4.5,1.8-10,4.1c-5.5,2.3-10,4.1-10,4.1S267.9,89.9,273.4,87.6z"
}), React.createElement("path", {
  className: "st34",
  d: "M277.9,97.5c1.6-5.4,7.8-6.5,7.8-6.5s-1.3,4.4-2.9,9.8c-1.6,5.4-2.9,9.8-2.9,9.8S276.3,102.9,277.9,97.5z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M284.4,74.2c-2.8,6.5,1,17.5,1,17.5s1.3-5.3,4.1-11.8c2.8-6.5,5.9-11.7,5.9-11.7S287.1,67.7,284.4,74.2z"
}), React.createElement("path", {
  className: "st34",
  d: "M293,78.8c-5.6,2.7-7.6,12.8-7.6,12.8s4.6-2.2,10.2-4.9c5.6-2.7,10.2-4.9,10.2-4.9S298.6,76.1,293,78.8z"
}), React.createElement("path", {
  className: "st34",
  d: "M295,88.8c-4.8-2.4-9.6,2.7-9.6,2.7s3.9,1.9,8.8,4.3c4.8,2.4,8.8,4.3,8.8,4.3S299.8,91.2,295,88.8z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M324.7,72.1c1.6,6-3.7,15.3-3.7,15.3s-0.4-4.8-2-10.8c-1.6-6-3.7-10.9-3.7-10.9S323.1,66.2,324.7,72.1z"
}), React.createElement("path", {
  className: "st34",
  d: "M315.9,75.4c4.8,2.9,5.1,12,5.1,12s-3.9-2.4-8.8-5.3c-4.8-2.9-8.8-5.3-8.8-5.3S311.1,72.4,315.9,75.4z"
}), React.createElement("path", {
  className: "st34",
  d: "M312,85.4c4.6-2.3,9,2,9,2s-3.7,1.9-8.3,4.2c-4.6,2.3-8.3,4.2-8.3,4.2S307.4,87.7,312,85.4z"
})), React.createElement("g", null, React.createElement("path", {
  className: "st34",
  d: "M331.5,75.2c-6,2.1-11.1,12.4-11.1,12.4s4.4-2.5,10.4-4.6c6-2.1,11.4-3,11.4-3S337.5,73.1,331.5,75.2z"
}), React.createElement("path", {
  className: "st34",
  d: "M333.6,85.1c-5.2-2.7-13.2,2.4-13.2,2.4s4.2,2.2,9.4,4.9c5.2,2.7,9.4,4.9,9.4,4.9S338.8,87.8,333.6,85.1z"
}), React.createElement("path", {
  className: "st34",
  d: "M327.1,94.7c-0.6-5.6-6.7-7.1-6.7-7.1s0.5,4.5,1.1,10.1c0.6,5.6,1.1,10.1,1.1,10.1S327.7,100.2,327.1,94.7z                 "
})), React.createElement("path", {
  className: "st34",
  d: "M304.9,120.9c-15.8,0-28.8,9-30.4,20.6c4.4,1.6,8.4,3.4,17.1,3.4c16,0,16-6,32-6c5.1,0,8.5,0.6,11.4,1.4             C332.8,129.4,320.2,120.9,304.9,120.9z"
}), React.createElement("path", {
  className: "st22",
  d: "M340,148.7h-45.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5H340c0.8,0,1.5-0.7,1.5-1.5S340.8,148.7,340,148.7z             "
}), React.createElement("path", {
  className: "st22",
  d: "M289.6,150.2c0-0.8-0.7-1.5-1.5-1.5h-14.4c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h14.4             C288.9,151.7,289.6,151,289.6,150.2z"
}), React.createElement("path", {
  className: "st22",
  d: "M327.4,157h-20.9c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h20.9c0.8,0,1.5-0.7,1.5-1.5S328.3,157,327.4,157z"
}), React.createElement("path", {
  className: "st22",
  d: "M301.4,158.5c0-0.8-0.7-1.5-1.5-1.5h-13.7c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h13.7             C300.7,160,301.4,159.4,301.4,158.5z"
}), React.createElement("path", {
  className: "st22",
  d: "M314.8,165.4h-15.9c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h15.9c0.8,0,1.5-0.7,1.5-1.5             S315.6,165.4,314.8,165.4z"
})), React.createElement("path", {
  className: "st34",
  d: "M72.9,56.3h-3.4v-3.4c0-0.6-0.4-1-1-1s-1,0.4-1,1v3.4h-3.4c-0.6,0-1,0.4-1,1s0.4,1,1,1h3.4v3.4         c0,0.6,0.4,1,1,1s1-0.4,1-1v-3.4h3.4c0.6,0,1-0.4,1-1S73.4,56.3,72.9,56.3z"
}), React.createElement("path", {
  className: "st34",
  d: "M151.1,74.2h-1.6v-1.6c0-0.6-0.4-1-1-1s-1,0.4-1,1v1.6h-1.6c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.6v1.6         c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.6h1.6c0.6,0,1-0.4,1-1S151.6,74.2,151.1,74.2z"
}), React.createElement("path", {
  className: "st37",
  d: "M128.2,46.7L128.2,46.7H124v-4.1c0-0.6-0.4-1-1-1c0,0,0,0,0,0s0,0,0,0c-0.6,0-1,0.4-1,1v4.1h-4.1h0         c-0.6,0-1,0.4-1,1s0.4,1,1,1h0h4.1v4.1c0,0.6,0.4,1,1,1c0,0,0,0,0,0s0,0,0,0c0.6,0,1-0.4,1-1v-4.1h4.1h0c0.6,0,1-0.4,1-1         S128.7,46.7,128.2,46.7z"
}), React.createElement("path", {
  className: "st37",
  d: "M68.2,103.3L68.2,103.3h-2.7v-2.7c0-0.6-0.4-1-1-1h0h0c-0.6,0-1,0.4-1,1v2.7h-2.7h0c-0.6,0-1,0.4-1,1         s0.4,1,1,1h0h2.7v2.7c0,0.6,0.4,1,1,1h0h0c0.6,0,1-0.4,1-1v-2.7h2.7h0c0.6,0,1-0.4,1-1S68.7,103.3,68.2,103.3z"
}), React.createElement("path", {
  className: "st5",
  d: "M304.9,120.9c-0.5,0-0.9,0-1.4,0v22.5c5.9-1.8,9.5-4.4,20.2-4.4c5.1,0,8.5,0.6,11.4,1.4         c-1.9-9.4-11.3-16.9-23.5-18.9c-0.1-8.2,1.2-21.6,9.3-29.4c0.2,1.6,0.4,3.5,0.6,5.6c0.6,5.6,1.1,10.1,1.1,10.1s5.2-7.5,4.6-13.1         c-0.3-2.4-1.6-4.1-3-5.2c1.6,0.8,3.5,1.8,5.7,2.9c5.2,2.7,9.4,4.9,9.4,4.9s-0.5-9.5-5.7-12.2c-2.6-1.3-5.8-0.7-8.5,0.2         c1.6-0.7,3.5-1.5,5.6-2.2c6-2.1,11.4-3,11.4-3s-4.7-6.9-10.7-4.8c-3.4,1.2-6.4,4.9-8.5,8c1.3-3.2,2.6-7.7,1.7-11         c-1.6-6-9.4-6.3-9.4-6.3s2.1,4.9,3.7,10.9c0.6,2.1,1,4.1,1.3,5.7c-0.7-2.6-2-5.6-4.4-7c-4.8-2.9-12.4,1.4-12.4,1.4s3.9,2.4,8.8,5.3         c2,1.2,3.8,2.3,5.3,3.2c-1.6-0.6-3.6-0.8-5.6,0.2c-4.6,2.3-7.6,10.3-7.6,10.3s3.7-1.9,8.3-4.2c0.4-0.2,0.7-0.4,1.1-0.5         c-7,9.2-8.3,21.7-8.2,30C305.4,120.9,305.1,120.9,304.9,120.9z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_9"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_10"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_11"
});

var SvgSimplifyJobs = function SvgSimplifyJobs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 399 210",
    style: {
      enableBackground: "new 0 0 400 210"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSimplifyJobs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simplify_jobs.e3428d0f.svg";
export { ForwardRef as ReactComponent };